import { setFulfilled, setPending, setRejected } from '@ms/yammer-data-support';
import { Reducer } from 'redux';

import { TrendingCampaignsLoadAction } from '../../domains/trendingCampaigns/loadActions.types';

import { TrendingCampaignsLifecycle } from './types';

const initialState: TrendingCampaignsLifecycle = {
  pending: false,
  fulfilled: undefined,
  rejected: undefined,
};

const reducer: Reducer<TrendingCampaignsLifecycle, TrendingCampaignsLoadAction> = (state = initialState, action) => {
  switch (action.type) {
    case 'TRENDING_CAMPAIGNS.LOAD_PENDING':
      return setPending();
    case 'TRENDING_CAMPAIGNS.LOAD_FULFILLED':
      return setFulfilled(action.payload.entities.trendingCampaigns);
    case 'TRENDING_CAMPAIGNS.LOAD_REJECTED':
      return setRejected(action.payload.error);
    default:
      return state;
  }
};

export default reducer;
